// Развилка создания курса (`CourseCreatePathDialog`) — глобальный overlay.
//
// Точек входа несколько: три кнопки «Новый курс» на `/courses` и карточка
// «Курс» в меню «+», которое живёт в шапке и в нижней навигации, то есть на
// ЛЮБОМ экране. Диалог при этом обязан быть один: второй смонтированный
// экземпляр открылся бы поверх первого на `/courses` (§7.3 frontend-ui —
// глобальные оверлеи открываются action'ом стора, а не локальным `useState`).
//
// Не персистится: при перезагрузке всегда закрыт.
//
// `entry` — с какой поверхности развилку открыли. Диалог смонтирован глобально
// и своего вызывающего не видит, поэтому источник обязан приехать вместе с
// командой открытия: иначе `course_create_path_chosen` не отвечает на главный
// вопрос §4.0 — работает ли глобальный «+» как вход в создание курса. Параметр
// ОБЯЗАТЕЛЬНЫЙ: необязательный молча превратил бы новую точку входа в дыру в
// воронке (а `onClick={open}` — ещё и в MouseEvent вместо источника).

import { create } from "zustand";

/** Поверхность, с которой открыли развилку (§4.0a — все входы в создание). */
export type CourseCreateEntry =
	| "courses-list"
	| "add-menu"
	| "dashboard"
	| "checklist"
	| "onboarding"
	| "how-it-works";

interface CourseCreatePathStore {
	isOpen: boolean;
	entry: CourseCreateEntry;
	open: (entry: CourseCreateEntry) => void;
	close: () => void;
	setOpen: (open: boolean) => void;
}

export const useCourseCreatePathStore = create<CourseCreatePathStore>((set) => ({
	isOpen: false,
	// Значение до первого открытия ничего не размечает: `entry` читается только
	// в обработчиках плиток, то есть уже после `open(...)`.
	entry: "courses-list",
	open: (entry) => set({ isOpen: true, entry }),
	close: () => set({ isOpen: false }),
	setOpen: (open) => set({ isOpen: open }),
}));
